<template>
  <CstuModal
    id="post-settings-modal"
    title="Post Settings"
    content-class="w-[650px]"
    dialog-class="!max-w-[650px]"
    body-class="no-scrollbar"
    scrollable
    size="lg"
    hide-footer
    centered
    radius="xl"
    no-close-on-backdrop
    @show="handleShow"
    @hidden="handleHide"
  >

    <PostSettingsForm
      :modal="true"
    />
  </CstuModal>
</template>

<script setup>
import { inject, ref } from 'vue'
import PostSettingsForm from '@src/modules/publisher/ai-content-library/components/form/PostSettingsForm.vue'

const root = inject('root')
const { $cstuModal } = root

const emit = defineEmits(['hide', 'settings-updated', 'generate'])

const isCustomGenerate = ref(false)


const handleShow = () => {
  // Any initialization when modal shows
}

const handleHide = () => {
  // Any cleanup when modal is hidden
  emit('hide')
}


// Expose methods for parent component
defineExpose({
  show: (customGenerate = false) => {
    isCustomGenerate.value = customGenerate
    $cstuModal.show('post-settings-modal')
  },
  hide: () => {
    $cstuModal.hide('post-settings-modal')
  },
})
</script>
